import { useState } from 'react';
import WeChatModal from './WeChatModal';

export default function Footer() {
  const [isWeChatModalOpen, setIsWeChatModalOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navigateToPage = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-950 text-gray-300 relative overflow-hidden">
      {/* 装饰性背景 */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-20 w-96 h-96 bg-teal-900 rounded-full mix-blend-multiply filter blur-3xl opacity-20"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-blue-900 rounded-full mix-blend-multiply filter blur-3xl opacity-20"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-12 sm:py-16 lg:py-20 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12">
          <div>
            <h2 className="text-3xl font-bold bg-gradient-to-r from-teal-400 to-blue-400 bg-clip-text text-transparent mb-4 sm:mb-6">
              智研云
            </h2>
            <p className="text-sm sm:text-base text-gray-400 mb-6 sm:mb-8 leading-relaxed">
              专业的研发费用管理系统,助力企业高效管理研发投入,精准核算研发成本,轻松应对税务审计。
            </p>
            <div className="flex space-x-3">
              <button 
                onClick={() => setIsWeChatModalOpen(true)}
                className="w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center bg-gray-800/80 rounded-xl hover:bg-gradient-to-r hover:from-teal-600 hover:to-teal-700 transition-all cursor-pointer hover:scale-110 hover:shadow-lg"
              >
                <i className="ri-wechat-fill text-lg sm:text-xl"></i>
              </button>
              <a href="#" className="w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center bg-gray-800/80 rounded-xl hover:bg-gradient-to-r hover:from-teal-600 hover:to-teal-700 transition-all cursor-pointer hover:scale-110 hover:shadow-lg">
                <i className="ri-weibo-fill text-lg sm:text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center bg-gray-800/80 rounded-xl hover:bg-gradient-to-r hover:from-teal-600 hover:to-teal-700 transition-all cursor-pointer hover:scale-110 hover:shadow-lg">
                <i className="ri-linkedin-fill text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 sm:mb-6 text-base sm:text-lg">产品</h4>
            <ul className="space-y-3 sm:space-y-4">
              <li>
                <button onClick={() => navigateToPage('/features')} className="text-sm sm:text-base hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap flex items-center group">
                  <i className="ri-arrow-right-s-line mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  产品功能
                </button>
              </li>
              <li>
                <button onClick={() => navigateToPage('/solutions')} className="text-sm sm:text-base hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap flex items-center group">
                  <i className="ri-arrow-right-s-line mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  解决方案
                </button>
              </li>
              <li>
                <button onClick={() => navigateToPage('/pricing')} className="text-sm sm:text-base hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap flex items-center group">
                  <i className="ri-arrow-right-s-line mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  价格方案
                </button>
              </li>
              <li>
                <a href="#" className="text-sm sm:text-base hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap flex items-center group">
                  <i className="ri-arrow-right-s-line mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  更新日志
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 sm:mb-6 text-base sm:text-lg">资源</h4>
            <ul className="space-y-3 sm:space-y-4">
              <li>
                <a href="#" className="text-sm sm:text-base hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap flex items-center group">
                  <i className="ri-arrow-right-s-line mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  帮助中心
                </a>
              </li>
              <li>
                <a href="#" className="text-sm sm:text-base hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap flex items-center group">
                  <i className="ri-arrow-right-s-line mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  API 文档
                </a>
              </li>
              <li>
                <a href="#" className="text-sm sm:text-base hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap flex items-center group">
                  <i className="ri-arrow-right-s-line mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  视频教程
                </a>
              </li>
              <li>
                <button onClick={() => navigateToPage('/faq')} className="text-sm sm:text-base hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap flex items-center group">
                  <i className="ri-arrow-right-s-line mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  常见问题
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 sm:mb-6 text-base sm:text-lg">联系我们</h4>
            <ul className="space-y-4 sm:space-y-5">
              <li className="flex items-center group">
                <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-teal-600/20 rounded-xl mr-3 sm:mr-4 group-hover:bg-teal-600/30 transition-colors flex-shrink-0">
                  <i className="ri-phone-line text-teal-400 text-base sm:text-lg"></i>
                </div>
                <span className="text-sm sm:text-base group-hover:text-white transition-colors">18123952850</span>
              </li>
              <li className="flex items-center group">
                <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-teal-600/20 rounded-xl mr-3 sm:mr-4 group-hover:bg-teal-600/30 transition-colors flex-shrink-0">
                  <i className="ri-mail-line text-teal-400 text-base sm:text-lg"></i>
                </div>
                <span className="text-sm sm:text-base group-hover:text-white transition-colors break-all">18123952850@139.com</span>
              </li>
              <li className="flex items-start group">
                <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-teal-600/20 rounded-xl mr-3 sm:mr-4 flex-shrink-0 group-hover:bg-teal-600/30 transition-colors">
                  <i className="ri-map-pin-line text-teal-400 text-base sm:text-lg"></i>
                </div>
                <span className="text-sm sm:text-base group-hover:text-white transition-colors leading-relaxed">深圳市福田区福田街道福安社区<br />福华一路98号卓越大厦2101-2110（2109C7）</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800/50 mt-12 sm:mt-16 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm sm:text-base gap-4">
          <p className="text-center md:text-left">
            &copy; 2024 智研云. 保留所有权利{' '}
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 transition-colors hover:text-teal-400"
            >
              粤ICP备2025507443号
            </a>
          </p>
        </div>
      </div>

      <WeChatModal isOpen={isWeChatModalOpen} onClose={() => setIsWeChatModalOpen(false)} />
    </footer>
  );
}
